import type { To } from 'history';
import { isDefinedObject } from '../../core';

export function getRelativeUrl(loc: To): string {

  let locStr: string = '';
  if (typeof loc === 'string') {
    locStr = loc;
  } else if (isDefinedObject(loc)) {
    locStr = [
      loc.pathname ?? '',
      loc.search ?? '',
      loc.hash ?? ''
    ].join('');
  }

  // if a base is not provided, URL might throw an error
  // however when a base is provided the URL constructor should not throw any error
  // we don't wrap this in a try..catch block because if an error does occurr
  // it means something really unusual happened and it's better to crash the app
  // than to return something that is misleading

  const url = new URL(locStr, window.location.origin);
  const relUrl = [url.pathname, url.search, url.hash].join('');

  return relUrl;
}

export function getAbsoluteUrl(loc: To, base: string = window.location.origin): string {
  if (typeof loc === 'string') {
    try {
      const url = new URL(loc);
      return url.href;
    } catch (_err) { }
  }

  // url is not absolute
  const url = new URL(getRelativeUrl(loc), base);
  return url.href;
}
